module.exports = __webpack_public_path__ + "media/images/preview_diary_2_thumb-88dbf4879423a27d738fab26e4cbcf66.webp";